




















































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CustomerContactInfo } from '@/models/filebunker/deal';
import { VoiceCallModel } from '@/models/fixedops/repairorder';
import {voiceCallService} from '@/shared';
import { Base } from './base';

@Component({
    computed: {
        trigger: {
            get() {
                return this.$props.flag;
            },
            set(val) {
                this.$emit('closedialog', val);
            },
        },
        checkCustomer: {
            get() {
                return (!this.customerInfo.homePhone || this.customerInfo.homePhone === '0') &&
                       (!this.customerInfo.businessPhone || this.customerInfo.businessPhone === '0') &&
                       (!this.customerInfo.cellPhone || this.customerInfo.cellPhone === '0') &&
                       (!this.customerInfo.phoneNumber || this.customerInfo.phoneNumber === '0');
            },
        },
    },
    props: ['customerInfo', 'flag', 'voiceCallModel', 'loading'],
})

export default class CallCustomerComponent extends Base {
    public selectedPhoneType: string = '';
    public trigger: boolean;
    public customerInfo: CustomerContactInfo;

    public voiceCallModel: VoiceCallModel;
    public requestProgress: boolean = false;

    public customerNumber() {
        let pNumber = '';
        switch (this.selectedPhoneType) {
            case 'rdHomePhone':
                pNumber = this.customerInfo.homePhone;
                break;
            case 'rdBusinessPhone':
                pNumber = this.customerInfo.businessPhone;
                break;
            case 'rdCellPhone':
                pNumber = this.customerInfo.cellPhone;
                break;
            case 'rdPhoneNumber':
                pNumber = this.customerInfo.phoneNumber;
                break;
            default:
                return '';
        }
        return pNumber;
    }

    public mounted(): void {
        // mounted block
    }

    public async callCustomer(): Promise<void> {
        const customerPhoneNumber = this.customerNumber();
        if (customerPhoneNumber === null || customerPhoneNumber === '' || customerPhoneNumber === '0') {
            this.showAlert(false, this.$parent.$t('callCustomer.alertCustomerNumberRequired'));
            return;
        }
        this.voiceCallModel.toNumber = customerPhoneNumber;
        try {
            this.requestProgress = true;

            const response = await voiceCallService.makeOutboundCallAsync(this.voiceCallModel);
            if (response.isSuccess) {
                this.showAlert(true, response.message);
            } else {
                this.showAlert(false, response.message);
            }
            this.trigger = false;
        } catch (e) {
            if (e.response.headers.status === '401') {
                this.showAlert(false, this.$parent.$t('callCustomer.alertYouAreNotAuthorized'));
            }
            this.trigger = false;
        } finally {
            this.requestProgress = false;
        }
    }
}
